import { render, staticRenderFns } from "./createPaxelMarketMainFeatures.vue?vue&type=template&id=0dddc584&"
import script from "./createPaxelMarketMainFeatures.vue?vue&type=script&lang=js&"
export * from "./createPaxelMarketMainFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports